import React from 'react';
import {BrowserRouter,Route,Switch} from 'react-router-dom';


import About from './porfolio/components/About';
import Projects from './porfolio/components/Projects';
import Contact from './porfolio/components/Contact';
import Card from './porfolio/components/Card';

import image from './image/App';
import hemisphere from './hemisphere/App';
import Landing from './Landing';


 
function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Switch>
        <Route exact path='/' component={Landing} />
        <Route path='/portfolio/App' component={About} />

        <Route path='/About' component={About} />
        <Route path='/Projects' component={Projects} />
        <Route path='/Contact' component={Contact} />
        <Route path='/card/:user' component={Card} />

        <Route path='/image/App' component={image} />
        <Route path='/hemisphere/App' component={hemisphere} />
        </Switch>
      </div>
    </BrowserRouter>
  );
}

export default App;
